/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

function ProcessedCashGrid({ data }: any) {
  return (
    <Grid data={data}>
      <Column
        field="category"
        title="Description"
        width="180px"
        className="grid-cell-font-size"
      />
      <Column
        field="notes"
        title="Total Notes"
        width="120px"
        className="grid-cell-font-size text-center"
        format="{0:N0}"
      />
      <Column
        field="amount"
        title="Net Amount"
        width="120px"
        className="grid-cell-font-size text-center"
      />
    </Grid>
  );
}

export default ProcessedCashGrid;
